import React from "react";
import { LOGO_URL } from "@/lib/api";

export const HitmasterLogo = ({ className = "h-20", ...rest }) => (
  <img
    src={LOGO_URL}
    alt="Hitmaster"
    className={`hm-logo-breathe ${className} w-auto object-contain select-none drop-shadow-[0_4px_0_rgba(30,27,75,0.15)]`}
    draggable={false}
    style={{ maxWidth: "100%" }}
    {...rest}
  />
);
